import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-plus",
  "use": "icon-si-glyph-plus-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-plus\" id=\"icon-si-glyph-plus\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1245</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16,6 L12,6 L12,2 C12,1.447 11.553,1 11,1 L7,1 C6.447,1 6,1.447 6,2 L6,6 L2,6 C1.447,6 1,6.447 1,7 L1,11 C1,11.553 1.447,12 2,12 L6,12 L6,16 C6,16.553 6.447,17 7,17 L11,17 C11.553,17 12,16.553 12,16 L12,12 L16,12 C16.553,12 17,11.553 17,11 L17,7 C17,6.447 16.553,6 16,6 L16,6 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-plus.svg
// module id = S+xJ
// module chunks = 62